const initialState = {
	loggedIn: false,
    email: [],
    mobile: [],
    name: ""
};

const user = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_USER_DATA_SUCCESS':
			return Object.assign([],state,{ ...action.payload });
		case 'GET_USER_DATA_FAILURE':
			return Object.assign([],state, {});
		case 'SET_USER_DATA':
			return Object.assign([],state, { ...action.data });
		default:
			return state;
	}
};

export default user;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/user.js